import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { App, Button, Dropdown, Popconfirm, Popover, Space, Tag } from 'antd';
import React, { useRef, useState } from 'react';
import { queryKeys } from '../../services/react-query/queryKeys';
import {
  MdDelete,
  MdInventory,
  MdModeEditOutline,
  MdSubtitles,
} from 'react-icons/md';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import {
  cancelMaterialRequest,
  deleteMaterialRequest,
  getMaterialRequest,
  submitMaterialRequest,
} from '../../network/materialRequest';
import StatusTag from '../../hooks/StatusHook';
import { useNavigate } from 'react-router-dom';
import { FaShoppingBasket } from 'react-icons/fa';
import { TiCancel } from 'react-icons/ti';
import PropsSearchTable from '../../components/common/PropsSearchTable/PropsSearchTable';
import DashboardCards from '../Dashboard/DashboardCards';
import { PiDotsThreeVerticalBold } from 'react-icons/pi';

const MaterialRequest = ({ t }) => {
  const navigate = useNavigate();
  const client = useQueryClient();
  const { message } = App.useApp();
  const searchInput = useRef(null);
  const searchInputMobile = useRef(null);
  const [textValue, setTextValue] = useState('');
  const [searchText, setSearchText] = useState({
    value: '',
    key: '',
  });
  const handleSearch = (selectedKeys, confirm, key) => {
    confirm();
    // console.log(`Searching for: ${selectedKeys[0]}, key: ${key}`);
    setSearchText({ value: selectedKeys[0], key });
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    setSearchText({ value: '', key: '' });
  };
  const props = ({ key, name }) =>
    PropsSearchTable({
      key: key,
      name: name,
      setTextValue: setTextValue,
      textValue: textValue,
      setSearchText: setSearchText,
      searchInputMobile: searchInputMobile,
      searchInput: searchInput,
      handleSearch: handleSearch,
      handleReset: handleReset,
      t: t,
    });
  const handleRemove = useMutation({
    mutationFn: (id) => deleteMaterialRequest(id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message ? data?.message : 'Deleted successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getMaterialRequest] });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const handleCancle = useMutation({
    mutationFn: (id) => cancelMaterialRequest('Material Request', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message || 'Cancled successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getMaterialRequest] });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const handleSubmit = useMutation({
    mutationFn: (id) => submitMaterialRequest('Material Request', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message || 'Submitted successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getMaterialRequest] });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getMaterialRequest, searchText.key, searchText.value],
    queryFn: () =>
      getMaterialRequest({
        key: searchText.key,
        value: searchText.value,
      }),
    keepPreviousData: true,
  });
  const items = (record) => [
    {
      key: '1',
      label: t.edit + ' ' + t.MaterialRequest,
      icon: <MdModeEditOutline />,
      disabled: record?.docstatus !== 0,
      onClick: () => {
        navigate(`/edit-material-request/${record?.name}`);
      },
    },
    // {
    //   key: '2',
    //   label: t.view + ' ' + t.MaterialRequest,
    //   icon: <MdInventory />,
    //   disabled: record?.docstatus !== 1,
    //   // record?.status === 'Received' ||
    //   onClick: () => {
    //     navigate(`/view-material-request/${record?.name}`);
    //   },
    // },
    {
      key: '3',
      label: t.AddStockEntry,
      icon: <MdInventory />,
      disabled: !(
        record?.docstatus === 1 && record?.material_request_type !== 'Purchase'
      ),
      onClick: () => {
        navigate(`/material/stock-entry-add/${record?.name}`);
      },
    },
    {
      key: '4',
      label: t.purchaseOrder,
      icon: <FaShoppingBasket />,
      // disabled:
      //   record?.docstatus !== 1 ||
      //   record?.status === 'Received' ||
      //   record?.status === 'Cancelled',
      disabled: !(
        record?.docstatus === 1 &&
        record?.status === 'Pending' &&
        record?.material_request_type === 'Purchase'
      ),
      onClick: () => {
        navigate(`/add-purchase-order-material/${record?.name}`);
      },
    },
    {
      key: '5',
      label: t.submit,
      icon: <MdSubtitles />,
      disabled: record?.docstatus === 1,
      onClick: () => {
        handleSubmit.mutate(record?.name);
      },
    },
    {
      key: '6',
      label: t.Cancel,
      icon: <TiCancel />,
      disabled: record?.docstatus !== 1,
      onClick: () => {
        handleCancle.mutate(record?.name);
      },
    },
    {
      type: 'divider',
    },
    {
      key: '8',
      disabled: record?.docstatus === 1,
      label: (
        <Popconfirm
          title={t.DeletetheMaterialWarehouse + ` (${record?.name})`}
          description={t.areYouSure}
          onConfirm={() => handleRemove.mutate(record?.name)}
          // onCancel={cancel}
          okText={t.yes}
          cancelText={t.no}
        >
          <span style={{ color: 'red' }}>
            {t.Delete} {t.MaterialRequest}
          </span>
        </Popconfirm>
      ),
      icon: <DeleteOutlined style={{ color: 'red' }} />,
    },
  ];
  const columns = [
    {
      title: t.Name,
      dataIndex: 'name',
      key: 'name',
      ...props({ key: 'name', name: t.Name }),
      render: (text, record) => {
        return (
          <span
            style={{ cursor: 'pointer' }}
            className="text-primary"
            onClick={() => {
              navigate(`/edit-material-request/${record.name}`);
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: t.owner,
      dataIndex: 'owner',
      key: 'owner',
      ...props({ key: 'owner', name: t.owner }),
    },
    {
      title: t.materialRequestType,
      dataIndex: 'material_request_type',
      key: 'material_request_type',
      ...props({ key: 'material_request_type', name: t.materialRequestType }),
    },
    {
      title: t.scheduleDate,
      dataIndex: 'schedule_date',
      key: 'schedule_date',
      ...props({ key: 'schedule_date', name: t.scheduleDate }),
    },
    {
      title: t.transactionDate,
      dataIndex: 'transaction_date',
      key: 'transaction_date',
    },
    {
      title: t.status,
      dataIndex: 'status',
      ...props({ key: 'status', name: t.status }),
      render: (text, record) =>
        record?.docstatus === 0 ? (
          <StatusTag status={'Draft'} />
        ) : (
          <StatusTag status={record?.status} />
        ),
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: 100,
      render: (text, record) => {
        return (
          <Space>
            {/* <Button
              size="small"
              type="primary"
              onClick={() => {
                navigate(`/edit-material-request/${record?.name}`);
              }}
              icon={<MdModeEditOutline />}
            />
            {record?.docstatus === 1 &&
              record?.status === 'Pending' &&
              record?.material_request_type === 'Purchase' && (
                <Popover
                  placement="top"
                  title={t.purchaseOrder}
                  onClick={() => {
                    navigate(`/add-purchase-order-material/${record?.name}`);
                  }}
                >
                  <Button
                    size="small"
                    type="primary"
                    icon={<FaShoppingBasket />}
                    style={{
                      backgroundColor: '#2a9790',
                    }}
                  />
                </Popover>
              )}
            {record?.docstatus === 1 &&
              record?.material_request_type !== 'Purchase' && (
                <Popover
                  placement="top"
                  title={t.AddStockEntry}
                  onClick={() => {
                    navigate(`/material/stock-entry-add/${record?.name}`);
                  }}
                >
                  <Button
                    size="small"
                    type="primary"
                    icon={<MdInventory />}
                    style={{
                      backgroundColor: '#2a4897',
                    }}
                  />
                </Popover>
              )}
            {
              // record?.status === 'Received' ||
              //   (record?.status !== 'Cancelled' && (
              record?.docstatus !== 1 && (
                <Popover
                  placement="top"
                  title={t.submit}
                  onClick={() => {
                    handleSubmit.mutate(record?.name);
                  }}
                >
                  <Button
                    size="small"
                    type="primary"
                    style={{ backgroundColor: '#28a745' }}
                    icon={<MdSubtitles />}
                  />
                </Popover>
              )
            }
            {record?.docstatus === 1 && (
              <Popover
                placement="top"
                title={t.Cancel}
                onClick={() => {
                  handleCancle.mutate(record?.name);
                }}
              >
                <Button
                  size="small"
                  type="primary"
                  style={{ backgroundColor: '#ff4d4f' }}
                  icon={<TiCancel />}
                />
              </Popover>
            )}
            {record?.docstatus !== 1 && (
              <Popconfirm
                title={t.DeletetheMaterialWarehouse + ` (${record?.name})`}
                description={t.areYouSure}
                onConfirm={() => handleRemove.mutate(record?.name)}
                okText={t.yes}
                cancelText={t.no}
              >
                <Button
                  size="small"
                  type="primary"
                  danger
                  icon={<MdDelete />}
                />
              </Popconfirm>
            )} */}
            <Dropdown
              menu={{ items: items(record) }}
              overlayClassName="custom-dropdown"
              trigger={['click']}
            >
              <Button
                type="text"
                icon={<PiDotsThreeVerticalBold size={20} color="#86888C" />}
              />
            </Dropdown>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => {
    return {
      key: index,
      ...item,
    };
  });
  return (
    <div className="inventory">
      {/* <Heading title={t.Inventory} subTitle={t.MaterialRequest} path="/" /> */}
      <DashboardCards t={t} />
      <div className="mt-5">
        <DynamicTableAnt
          columns={columns}
          data={dataTable}
          loading={isLoading}
          setSearchText={setSearchText}
          Placeholder={t.searchByName}
          buttonModal={
            <Button
              type="primary"
              onClick={() => {
                navigate('/add-material-request');
              }}
            >
              <PlusOutlined
                style={{
                  fontSize: '10px',
                }}
              />
              {t.addMaterialRequest}
            </Button>
          }
        />
      </div>
    </div>
  );
};

export default MaterialRequest;
